var app = angular.module('leonardo');

var WidgetFieldText = function(scope) {
  scope.isRequired = function() {
    if (!isEmpty(scope.field.data)) {
      if (scope.mode === 'property') {
        return !!scope.field.data.property_required && (scope.field.data.property_widget !== 'hidden');
      }
      if (scope.mode === 'template') {
        return !!scope.field.data.template_required && (scope.field.data.template_widget !== 'hidden');
      }
    }
    return false;
  };
};

var WidgetField = function() {
  return {
    restrict: 'A',
    templateUrl: 'views/templates/widget/field/field.html',
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      field: '=',
      field_data: '=fieldData',
      mode: '@'
    },
    link: function (scope, element, attrs) {
      if(scope.field.type == 'text'){
        WidgetFieldText(scope);
      }

      scope.isRequired = function() {
        if (!isEmpty(scope.field.data)) {
          if (scope.mode === 'property') {
            return !!scope.field.data.property_required && (scope.field.data.property_widget !== 'hidden');
          }
          if (scope.mode === 'template') {
            return !!scope.field.data.template_required && (scope.field.data.template_widget !== 'hidden');
          }
        }
        return false;
      };

      scope.setWidget = function() {
        scope.widget = scope.field.type;
        if (scope.field.type && scope.field.data.options) {
          scope.widget = 'combo';
        }
      };

      scope.setWidget();
    }
  };
};

app.directive('widgetField', [WidgetField]);
